import React, {useEffect} from 'react';
import { connect } from "react-redux";
import {setPhoneNumber, setIDKYC, setLanguageWebsite} from './bll/AuthReducer'
import './App.scss';
import {Routes, Route} from 'react-router-dom'
import HomeScreen from './screen/HomeScreen/HomeScreen';
import {PersonalAccount} from './screen/PersonalAccount/PersonalAccount'
import { MobilePhone } from './screen/SignUp/MobilePhone/MobilePhone';
import BuyToken from './screen/BuyToken/BuyToken';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { checkToken, isExpiredToken } from './utilities/utilities';
import { useTranslation } from "react-i18next";

function App(props:any) {

  const {t, i18n} = useTranslation()

  useEffect(() => {
    // if(localStorage.getItem('token')){}
    //   localStorage.setItem('token', 'eyJhbGciOiJIUzUxMiJ9.eyJwaG9uZU51bWJlciI6IjQ4Nzk3NDk0OTQzIiwiZXhwIjoxNjY1NTgyMjU4LCJpYXQiOjE2NjU1ODA0NTgsImlkZW50aWZpY2F0aW9uSWQiOiJjMTZlYjVlZDk3Nzc0ZGI1ODIxZjMwNTYyOGE4M2FmMyJ9.DDffEOgauRfrgzmD8EkB7vxpSIsoKMQ55fkKFLBU6APity-u0d5d3GboVuLotH72A5__D3IA3Ji3vTUq0hSdpw');
    //   const token: any = localStorage.getItem('token')
    //   const decoded: any = jwt_decode(token || '')
    //   const number :any = decoded.phoneNumber
    //   const idKYC :any = decoded.identificationId
    //   // console.log('token info', number, idKYC)
    //   props.setPhoneNumber(number)
    //   props.setIDKYC(idKYC)
    i18n.changeLanguage('EN')
    props.setLanguageWebsite('EN')
    if(localStorage.getItem('token')){
      isExpiredToken()
    }
  },[])

  function getKycStatus () {
    
  }

  return (
    <div className='App'>
      <img src={require('./img/Noise.png')} className='noize'/>
      <Routes>
        <Route path='/' element = {<HomeScreen />}/>
        <Route path='/personalAccount' element = {<PersonalAccount />}/>
        <Route path='/cpayToken' element = {<BuyToken />}/>
        <Route path='/signUp' element = {<MobilePhone />}/>
      </Routes>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  data: state.AuthReducer,
})

export default connect(mapStateToProps, {setPhoneNumber, setIDKYC, setLanguageWebsite})(App)
